import { Api } from "../../Api/Api";

export const forgotApi =(data)=> Api.post('api/forgotPassword',data)
 